import MasterTab from 'src/components/Layouts/MasterTab.vue';
import State from 'src/views/Pages/Dashboard/Sigatoka/State/State.vue';
import Config from 'src/views/Pages/Dashboard/Sigatoka/Config/Config.vue';
import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';
import EditCreate from 'src/views/Pages/Dashboard/Sigatoka/SigatokaCapture/EditCreate.vue';
import SigatokaCapture from 'src/views/Pages/Dashboard/Sigatoka/SigatokaCapture/SigatokaCapture.vue';

const SigatokaRouters = {
  path: 'sigatoka',
  name: 'sigatoka.sigatoka',
  component: MasterTab,
  props: { reference: 'sigatokaTabs' },
  children: [
    {
      path: 'config',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'sigatoka.sigatoka',
          component: Config,
          meta: {
            prefix_permission: 'sigatoka_evaluationleaves',
          },
        },
      ],
    },
    {
      path: 'state',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'sigatoka.sigatoka',
          component: State,
          meta: {
            prefix_permission: 'sigatoka_state',
          },
        },
      ],
    },
    {
      path: 'capture',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'sigatoka.sigatoka_capture',
          component: SigatokaCapture,
          meta: {
            prefix_permission: 'sigatoka_capture',
          },
        },
        {
          path: 'editcreate',
          name: 'sigatoka.sigatoka_capture',
          component: EditCreate,
          meta: {
            prefix_permission: 'sigatoka_capture',
          },
        },
      ],
    },
  ],
};

export default SigatokaRouters;
